<template>
  <div class="ly_modal_container" :style="{ width: '1020px', zIndex }">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">도움말</h1>
    </div>
    <div class="ly_modal_content">
      <div :style="{marginBottom: '20px'}">
        <select v-model="categoryId">
          <option value>메뉴 선택</option>
          <option
            v-for="category in helpData"
            :value="category.id"
            :key="category.id"
          >{{ category.name }}</option>
        </select>
      </div>

      <ScrollTable
        :sourceList="categoryItems"
        :scrollHeight="'500px'"
        :key="categoryId"
        ref="table"
      >
        <template #header>
          <caption>
            <span class="blind">{{ categoryName }}</span>
          </caption>
          <colgroup>
            <col width="20%" />
            <col width="15%" />
            <col />
          </colgroup>
          <thead class="table_list_head table_list_head_line">
            <tr>
              <th>메뉴</th>
              <th>항목</th>
              <th>설명</th>
            </tr>
          </thead>
        </template>
        <template #row="{rowData}">
          <tr :data-id="rowData.id" :class="{highlight: rowData.id === focusId}">
            <td v-html="$utils.nl2br(rowData.categoryName)"></td>
            <td>{{rowData.name}}</td>
            <td class="left" v-html="$utils.nl2br(rowData.content)"></td>
          </tr>
        </template>
      </ScrollTable>

      <div class="btn_area">
        <button type="button" class="btn_default" @click="close">닫기</button>
      </div>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import popupMixin from "$mixins/popup";
import helpData from "./data.json";

// helpData에 categoryName 추가
helpData.forEach(cat => cat.children.forEach(item => item.categoryName = cat.name));

export default {
  mixins: [popupMixin],
  props: {
    contentId: {
      type: String,
      default: ""
    }
  },
  data() {
    const isCategoryId = isCategory(this.contentId);
    const categoryId = isCategoryId
      ? this.contentId
      : findCategoryIdByContentId(this.contentId);
    const focusId = isCategoryId ? null : this.contentId;

    return {
      categoryId,
      focusId,
      helpData
    };
  },
  watch: {
    categoryId() {
      this.focusId = null;
    }
  },
  computed: {
    category() {
      return helpData.find(item => item.id == this.categoryId);
    },
    categoryItems() {
      if (!this.category)
        return helpData.reduce((result, cat) => {
          return result.concat(cat.children);
        }, []);
      else return this.category.children;
    },
    categoryName() {
      if (!this.category) return "전체 메뉴";
      return this.category.name;
    }
  },
  methods: {
    scrollTo(id) {
      const offsetTop = this.$el.querySelector(`[data-id="${id}"]`).offsetTop;
      this.$refs.table.scrollTo(0, offsetTop);
    }
  },
  mounted() {
    if (this.focusId) this.$nextTick(() => this.scrollTo(this.focusId));
  }
};

function isCategory(id) {
  return helpData.some(category => category.id === id);
}

function findCategoryIdByContentId(contentId) {
  let result;
  helpData.some(category =>
    category.children.some(item => {
      if (item.id === contentId) {
        result = category.id;
        return true;
      }
    })
  );
  return result;
}
</script>
